// store.ts
import { configureStore } from '@reduxjs/toolkit';
import layoutReducer from './layoutSlice';
import projectSelectionReducer from './projectSelectionSlice';
import roleReducer from './rolesSlice';

export const store = configureStore({
  reducer: {
    layout: layoutReducer,
    projectSelection: projectSelectionReducer,
    role: roleReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
